import {Paper, Typography} from '@mui/material'

interface TableEmptyStateProps {
  message?: string;
}

function TableEmptyState({message = 'No data available'}: TableEmptyStateProps) {
  return (
    <Paper elevation={2} sx={{p: 3, minHeight: 200, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Typography variant="h6">{message}</Typography>
    </Paper>
  )
}

export {TableEmptyState}